import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["textContent"]
const _hoisted_2 = { class: "table-header-item-count" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { key: 3 }
const _hoisted_7 = {
  colspan: "8",
  class: "pr-5"
}
const _hoisted_8 = { class: "elevation-2 rounded-lg pa-4 ma-3 bg-surface-dark" }
const _hoisted_9 = { class: "font-weight-bold" }
const _hoisted_10 = { class: "font-weight-bold" }
const _hoisted_11 = { class: "font-weight-bold" }
const _hoisted_12 = { class: "font-weight-bold" }
const _hoisted_13 = { class: "font-weight-bold" }
const _hoisted_14 = { class: "font-weight-bold" }
const _hoisted_15 = { class: "font-weight-bold" }
const _hoisted_16 = { class: "font-weight-bold" }
const _hoisted_17 = { class: "font-weight-bold" }
const _hoisted_18 = { class: "font-weight-bold" }
const _hoisted_19 = { class: "font-weight-bold" }
const _hoisted_20 = { class: "font-weight-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_TableHeader = _resolveComponent("TableHeader")!
  const _component_TextHighlights = _resolveComponent("TextHighlights")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_data_table_server = _resolveComponent("v-data-table-server")!
  const _component_v_infinite_scroll = _resolveComponent("v-infinite-scroll")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_SingleFilter = _resolveComponent("SingleFilter")!
  const _component_FilterDrawer = _resolveComponent("FilterDrawer")!

  return (_openBlock(), _createBlock(_component_v_container, { fluid: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_infinite_scroll, {
                ref: "infiniteScroll",
                onLoad: _ctx.load
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_data_table_server, {
                    "sort-by": _ctx.sortBy,
                    "onUpdate:sortBy": [
                      _cache[3] || (_cache[3] = ($event: any) => ((_ctx.sortBy) = $event)),
                      _ctx.onSortByChanged
                    ],
                    headers: _ctx.headers,
                    items: _ctx.tvsKundenListe,
                    loading: _ctx.loading,
                    "items-length": _ctx.totalNumberOfRecords || 0,
                    "must-sort": true,
                    "item-value": "tvsKundennummer",
                    hover: "",
                    "show-expand": "",
                    "hide-default-footer": "",
                    class: "elevation-1 nowhow-table"
                  }, {
                    top: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        sm: "12",
                        class: "pb-0"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_row, { cols: "auto" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("h3", {
                                    class: "pl-3",
                                    textContent: _toDisplayString(_ctx.$t('lieferant.tvskundenliste.list.title'))
                                  }, null, 8, _hoisted_1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, { cols: "auto" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_tooltip, { location: "bottom" }, {
                                    activator: _withCtx(({ props }) => [
                                      _createVNode(_component_v_btn, _mergeProps({
                                        class: "px-1 mr-2",
                                        style: {"min-width":"160px"},
                                        color: "primary"
                                      }, props, { onClick: _ctx.downloadTvsKundenListe }), {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.$t('lieferant.tvskunden.button.download.csv')), 1)
                                        ]),
                                        _: 2
                                      }, 1040, ["onClick"])
                                    ]),
                                    default: _withCtx(() => [
                                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('lieferant.tvskunden.button.download.csv.tooltip')), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_TableHeader, {
                        filters: _ctx.filters,
                        onChipClosed: _ctx.removeFilter
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.totalNumberOfRecords + ' ' + _ctx.$t('archiv.table.header.items')), 1),
                          (_ctx.showSearchBar)
                            ? (_openBlock(), _createBlock(_component_v_text_field, {
                                key: 0,
                                modelValue: _ctx.filterData.suchText,
                                "onUpdate:modelValue": [
                                  _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filterData.suchText) = $event)),
                                  _ctx.searchFieldInputChanged
                                ],
                                class: "ml-5",
                                "prepend-inner-icon": "mdi-magnify",
                                "append-inner-icon": "mdi-close",
                                label: _ctx.$t('suche'),
                                "hide-details": "",
                                autofocus: "",
                                "onClick:appendInner": _ctx.searchBarClosed
                              }, null, 8, ["modelValue", "label", "onUpdate:modelValue", "onClick:appendInner"]))
                            : _createCommentVNode("", true),
                          _createVNode(_component_v_spacer),
                          (!_ctx.showSearchBar)
                            ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                key: 1,
                                top: "",
                                color: "secondary"
                              }, {
                                activator: _withCtx(({ props }) => [
                                  _createVNode(_component_v_btn, _mergeProps(props, {
                                    icon: "",
                                    color: "primary"
                                  }), {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_icon, {
                                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showSearchBar = !_ctx.showSearchBar))
                                      }, {
                                        default: _withCtx(() => _cache[9] || (_cache[9] = [
                                          _createTextVNode("mdi-magnify")
                                        ])),
                                        _: 1
                                      })
                                    ]),
                                    _: 2
                                  }, 1040)
                                ]),
                                default: _withCtx(() => [
                                  _createElementVNode("div", null, [
                                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('tableheader.tooltip.search')), 1)
                                  ])
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          _createVNode(_component_v_tooltip, {
                            top: "",
                            color: "secondary"
                          }, {
                            activator: _withCtx(({ props }) => [
                              _createVNode(_component_v_btn, _mergeProps(props, {
                                icon: "",
                                color: "primary",
                                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showFilterDrawer = !_ctx.showFilterDrawer))
                              }), {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, null, {
                                    default: _withCtx(() => _cache[10] || (_cache[10] = [
                                      _createTextVNode("mdi-filter-outline")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 2
                              }, 1040)
                            ]),
                            default: _withCtx(() => [
                              _createElementVNode("div", null, [
                                _createElementVNode("span", null, _toDisplayString(_ctx.$t('tableheader.tooltip.filter')), 1)
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["filters", "onChipClosed"])
                    ]),
                    "item.tvsKundennummer": _withCtx(({ item }) => [
                      _createVNode(_component_TextHighlights, {
                        text: item.tvsKundennummer,
                        "search-text": _ctx.filterData.suchText
                      }, null, 8, ["text", "search-text"])
                    ]),
                    "item.name": _withCtx(({ item }) => [
                      _createVNode(_component_TextHighlights, {
                        text: item.name,
                        "search-text": _ctx.filterData.suchText
                      }, null, 8, ["text", "search-text"])
                    ]),
                    "item.vorname": _withCtx(({ item }) => [
                      _createVNode(_component_TextHighlights, {
                        text: item.vorname,
                        "search-text": _ctx.filterData.suchText
                      }, null, 8, ["text", "search-text"])
                    ]),
                    "item.firma": _withCtx(({ item }) => [
                      _createVNode(_component_TextHighlights, {
                        text: item.firma,
                        "search-text": _ctx.filterData.suchText
                      }, null, 8, ["text", "search-text"])
                    ]),
                    "item.plz": _withCtx(({ item }) => [
                      _createVNode(_component_TextHighlights, {
                        text: item.plz,
                        "search-text": _ctx.filterData.suchText
                      }, null, 8, ["text", "search-text"])
                    ]),
                    "item.ort": _withCtx(({ item }) => [
                      _createVNode(_component_TextHighlights, {
                        text: item.ort,
                        "search-text": _ctx.filterData.suchText
                      }, null, 8, ["text", "search-text"])
                    ]),
                    "item.hatRechnungenNurViaVetdata": _withCtx(({ item }) => [
                      _createTextVNode(_toDisplayString(_ctx.$t(item.hatRechnungenNurViaVetdata ? 'filter.ja' : 'filter.nein')), 1)
                    ]),
                    "item.status": _withCtx(({ item }) => [
                      (item.geloescht && item.gesperrt)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.$t('benutzerSuche.table.gesperrtundgeloescht')), 1))
                        : (item.gesperrt)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.$t('benutzerSuche.table.gesperrt')), 1))
                          : (item.geloescht)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.$t('benutzerSuche.table.geloescht')), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.$t('benutzerSuche.table.aktiv')), 1))
                    ]),
                    "item.data-table-expand": _withCtx(({ internalItem, isExpanded, toggleExpand }) => [
                      _createVNode(_component_v_btn, {
                        icon: "",
                        class: "elevation-0",
                        onClick: ($event: any) => (toggleExpand(internalItem))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(isExpanded(internalItem) ? 'mdi-chevron-up' : 'mdi-chevron-down'), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    "expanded-row": _withCtx(({ item }) => [
                      _createElementVNode("td", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                          _createVNode(_component_v_container, { fluid: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_row, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, {
                                    cols: "12",
                                    md: "4"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("h5", _hoisted_9, _toDisplayString(_ctx.$t('tvskundeliste.details.table.header.name')), 1),
                                      _createElementVNode("p", null, _toDisplayString(item.anrede) + " " + _toDisplayString(item.vorname) + " " + _toDisplayString(item.name), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_v_col, {
                                    cols: "12",
                                    md: "4"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("h5", _hoisted_10, _toDisplayString(_ctx.$t('tvskundeliste.details.table.header.tvsKundennummer')), 1),
                                      _createElementVNode("p", null, _toDisplayString(item.tvsKundennummer), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_v_col, {
                                    cols: "12",
                                    md: "4"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("h5", _hoisted_11, _toDisplayString(_ctx.$t('tvskundeliste.details.table.header.hatRechnungenNurViaVetdata')), 1),
                                      _createElementVNode("p", null, _toDisplayString(_ctx.$t(item.hatRechnungenNurViaVetdata ? 'filter.ja' : 'filter.nein')), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_v_row, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, {
                                    cols: "12",
                                    md: "4"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("h5", _hoisted_12, _toDisplayString(_ctx.$t('taketeilnehmer.table.firma')), 1),
                                      _createElementVNode("p", null, _toDisplayString(item.firma), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_v_col, {
                                    cols: "12",
                                    md: "4"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("h5", _hoisted_13, _toDisplayString(_ctx.$t('tvskundeliste.details.table.header.sprache')), 1),
                                      _createElementVNode("p", null, _toDisplayString(item.sprache?.toUpperCase()), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_v_col, {
                                    cols: "12",
                                    md: "4"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("h5", _hoisted_14, _toDisplayString(_ctx.$t('tvskundeliste.details.table.header.gesperrt')), 1),
                                      _createElementVNode("p", null, _toDisplayString(_ctx.$t(item.gesperrt ? 'filter.ja' : 'filter.nein')), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_v_row, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, {
                                    cols: "12",
                                    md: "4"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("h5", _hoisted_15, _toDisplayString(_ctx.$t('tvskundeliste.details.table.header.strasse')), 1),
                                      _createElementVNode("p", null, _toDisplayString(item.strasse) + " " + _toDisplayString(item.hausNummer), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_v_col, {
                                    cols: "12",
                                    md: "4"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("h5", _hoisted_16, _toDisplayString(_ctx.$t('tvskundeliste.details.table.header.telefon')), 1),
                                      _createElementVNode("p", null, _toDisplayString(item.telefon), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_v_col, {
                                    cols: "12",
                                    md: "4"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("h5", _hoisted_17, _toDisplayString(_ctx.$t('tvskundeliste.details.table.header.geloescht')), 1),
                                      _createElementVNode("p", null, _toDisplayString(_ctx.$t(item.geloescht ? 'filter.ja' : 'filter.nein')), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_v_row, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, {
                                    cols: "12",
                                    md: "4"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("h5", _hoisted_18, _toDisplayString(_ctx.$t('tvskundeliste.details.table.header.plz')) + " / " + _toDisplayString(_ctx.$t('tvskundeliste.details.table.header.ort')), 1),
                                      _createElementVNode("p", null, _toDisplayString(item.plz) + " " + _toDisplayString(item.ort), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_v_row, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, {
                                    cols: "12",
                                    md: "4"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("h5", _hoisted_19, _toDisplayString(_ctx.$t('tvskundeliste.details.table.header.zusPlz')), 1),
                                      _createElementVNode("p", null, _toDisplayString(item.zusPlz), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_v_row, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, {
                                    cols: "12",
                                    md: "4"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("h5", _hoisted_20, _toDisplayString(_ctx.$t('tvskundeliste.details.table.header.landcode')), 1),
                                      _createElementVNode("p", null, _toDisplayString(item.landcode), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["sort-by", "headers", "items", "loading", "items-length", "onUpdate:sortBy"])
                ]),
                _: 1
              }, 8, ["onLoad"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_FilterDrawer, {
        visible: _ctx.showFilterDrawer,
        onCancel: _cache[6] || (_cache[6] = ($event: any) => (_ctx.cancelFilter())),
        onConfirm: _cache[7] || (_cache[7] = ($event: any) => (_ctx.confirmFilter())),
        onReset: _cache[8] || (_cache[8] = ($event: any) => (_ctx.resetFilter()))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_SingleFilter, {
            title: _ctx.$t('taketeilnehmer.table.header.status')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { sm: "12" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_select, {
                        modelValue: _ctx.filterData.status,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filterData.status) = $event)),
                        filled: "",
                        dense: "",
                        "hide-details": "",
                        items: _ctx.status
                      }, null, 8, ["modelValue", "items"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["title"]),
          _createVNode(_component_SingleFilter, {
            title: _ctx.$t('taketeilnehmer.table.header.hatRechnungenNurViaVetdata')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { sm: "12" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_select, {
                        modelValue: _ctx.filterData.hatRechnungenNurViaVetdata,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filterData.hatRechnungenNurViaVetdata) = $event)),
                        filled: "",
                        dense: "",
                        "hide-details": "",
                        items: _ctx.hatRechnungenNurViaVetdata
                      }, null, 8, ["modelValue", "items"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["title"])
        ]),
        _: 1
      }, 8, ["visible"])
    ]),
    _: 1
  }))
}